"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var FormControl_1 = __importDefault(require("@mui/material/FormControl"));
var react_1 = require("@emotion/react");
var defaultProps_1 = __importDefault(require("./defaultProps"));
var makeFormControlStyles_1 = __importDefault(require("./makeFormControlStyles"));
var FormControl = function (_a) {
    var children = _a.children, error = _a.error, experimentName = _a.experimentName, _b = _a.isAutoFilledActive, isAutoFilledActive = _b === void 0 ? false : _b, _c = _a.isSafari, isSafari = _c === void 0 ? false : _c, otherProps = __rest(_a, ["children", "error", "experimentName", "isAutoFilledActive", "isSafari"]);
    var theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(FormControl_1.default, __assign({ variant: "standard", error: error, fullWidth: true, css: (0, makeFormControlStyles_1.default)({ isAutoFilledActive: isAutoFilledActive, isSafari: isSafari, theme: theme }) }, otherProps, { children: children })));
};
FormControl.defaultProps = defaultProps_1.default;
exports.default = FormControl;
//# sourceMappingURL=FormControl.js.map